module.exports = __webpack_public_path__ + "img/8 - Willie Theron.308eb1c4.jpg";